<template>
  <b-modal
    centered
    :hide-footer="true"
    modal-class="c-wrap"
    dialog-class="c-dialog-min"
    header-class="popup_header1"
    body-class="c-body container"
    :visible="visible"
    @show="onShow"
    @hide="onCancel"
  >
    <template #modal-header="{ close }">
      <span style="margin: auto">&nbsp;&nbsp;&nbsp;&nbsp;{{$t('more.account_title')}}</span>
      <b-img class="mo_close_btn"  @click="onCancel2" :src="require('../../../assets/image/ic_close2.png')"/>
    </template>
    <div class="bank-area">
      <span class="bank">{{$t('more.account_bank')}}</span><br/>
      <span class="account_no">{{$t('more.account_no')}}</span>
    </div>
    <div style="padding: 10px;margin: 10px 30px;">
      <span class="account_guide">{{$t('more.account_guide_1')}}</span><br/>
      <span class="account_guide" v-html="$t('more.account_guide_2')"></span><br/>
      <span class="account_guide" style="color: #8e8e8e;font-size: 18px;">{{$t('more.account_guide_3')}}</span><br/>
      <div style="height: 10px;"></div>
      <span class="account_notice" style="color: #cf0000">{{$t('more.account_notice1')}}</span><br/>
      <span class="account_notice" style="text-decoration-line: underline;">{{$t('more.account_notice2')}}</span><br/>
      <span class="account_notice">{{$t('more.account_notice3')}}</span>
    </div>
    <b-container style="padding: 0 70px;">
      <b-row>
        <b-col style="text-align: center"><button @click="onAccount($t('more.account_copy'))" class="btn copy_account_btn">{{$t('more.account_copy_button')}}</button></b-col>
        <b-col style="text-align: center"><button @click="onKakao" class="btn copy_account_btn" style="background-color:#f9e000; color:black;">{{$t('more.account_send')}}</button><br/><br/></b-col>
      </b-row>
    </b-container>

  </b-modal>
</template>

<script>
import moment from "moment";
import Utils from "../../../config/utils";

export default {
  name: "CopyAccountPopup",
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      fields:[],
      items: [],
      list: [],
      isClosed: false
    }
  },
  methods:{
    getList(){

    },
    onShow() {
      this.eventBus.$emit('setModal', this);
      window.history.pushState('forward', null, );
    },
    onCancel(){
      this.$emit('update:visible', false);
      if(!this.isClosed && window.history.state == "forward")
        window.history.back();
    },
    onCancel2(){
      if(window.history.state == "forward")
        window.history.back();
      this.isClosed = true;
    },
    onAccount(content) {
      Utils.copyAccount(this, content);
    },
    onKakao () {
      window.open('https://pf.kakao.com/_xgctis/chat', '_blank');
    },
  },
  inject: ['eventBus'],
  computed:{
  },
  watch:{
    visible(){
      if (this.visible){
        this.getList();
      }

    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/vars";

.c-header1{
  display: flex;
  font-size: $fs_16;
  font-family: $korean_gd_15_r
}

.bank-area {
  padding: 24px 0;
  background-color: #f8b500;
  text-align: center;
  margin-top: -1rem;
  margin-left: -1rem;
  margin-right: -1rem;
}

.bank{
  color: white;
  font-size: $fs_22;
  font-family: $korean_gd_15_r;
  margin-right: 10px;
}

.account_no{
  font-size: $fs_22;
  font-family: $korean_gd_15_r;
}

.account_guide{
  font-size: $fs_20;
  font-family: $korean_gd_15_r;
  color: #cf0000;
  margin-bottom: 0;
}

.account_notice{
  font-size: $fs_16;
  font-family: $korean_gd_15_r;
  //color: #7b7b7b;
  color:back;
  margin-top: 30px;
  margin-bottom: 0px;
}


</style>



// WEBPACK FOOTER //
// src/components/controls/popup/CopyAccountPopup.vue